import { PHONE_COUNTRIES } from '~/lib/englishAssessment';
import { fromPhoneDraft, toPhoneDraft, typedPhone } from '~/lib/whatsappPhone';
import { useT } from '~/i18n';

/**
 * País + número de WhatsApp, controlado por un borrador de texto
 * (`lib/whatsappPhone.ts`). Solo los dos controles: la etiqueta, la línea de
 * consentimiento y el error los pone quien lo usa, porque el cuestionario y el
 * alta tienen cada uno su forma de campo.
 */
export default function WhatsappPhoneInput({
  id,
  value,
  onChange,
  invalid = false,
  disabled = false,
  dataField,
}: {
  id: string;
  value: string;
  onChange: (draft: string) => void;
  invalid?: boolean;
  disabled?: boolean;
  /** Para que el cuestionario lleve el foco al campo con error. */
  dataField?: string;
}) {
  const t = useT('onboarding').whatsapp;
  const { dial, local } = fromPhoneDraft(value);

  return (
    <div className="flex gap-2">
      <select
        id={`${id}-country`}
        className="select shrink-0 w-auto max-w-[45%]"
        value={dial}
        disabled={disabled}
        onChange={(e) => onChange(toPhoneDraft({ dial: e.target.value, local }))}
        aria-label={t.country}
      >
        {PHONE_COUNTRIES.map((country) => (
          <option key={`${country.iso}-${country.dial}`} value={country.dial}>
            {country.name} +{country.dial}
          </option>
        ))}
      </select>
      <input
        id={id}
        data-field={dataField}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        className={`input flex-1 min-w-0${invalid ? ' input-error' : ''}`}
        placeholder={t.placeholder}
        value={local}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        onChange={(e) => onChange(typedPhone(dial, e.target.value))}
      />
    </div>
  );
}
